module.exports = __webpack_public_path__ + "static/media/realtors-icon-11.a8db5262.svg";